import { branch } from "baobab-react/higher-order";
import PropTypes from "baobab-react/prop-types";
import _ from "lodash";
import React from "react";
import autoBind from "react-autobind";
import { FontAwesomeIcon } from "../shared/FontAwesomeIconWrapper";
import * as playerActions from "../../actions/playerActions";
import OkButtonContext from "../../contexts/OkButtonContext";
import { getConfigParam } from "../../utils/config";
import { markdownToHtml } from "../../utils/markupUtils";
import * as Utils from "../../utils/utils";
import PlayerAddress from "../playerItemComponents/PlayerAddress";
import PlayerBarcodeScanner from "../playerItemComponents/PlayerBarcodeScanner";
import PlayerDatePicker from "../playerItemComponents/PlayerDatePicker";
import PlayerImagePicker from "../playerItemComponents/PlayerImagePicker";
// import ClickNHold from "react-click-n-hold";
import PlayerItem from "../playerItemComponents/PlayerItem";
import PlayerLocation from "../playerItemComponents/PlayerLocation";
import PlayerMultiChoice from "../playerItemComponents/PlayerMultiChoice";
import PlayerPicker from "../playerItemComponents/PlayerPicker";
import PlayerRanking from "../playerItemComponents/PlayerRanking";
import PlayerSingleChoice from "../playerItemComponents/PlayerSingleChoice";
import PlayerSketchpad from "../playerItemComponents/PlayerSketchpad";
import PlayerTextInput from "../playerItemComponents/PlayerTextInput";
import PlayerTextInputMultiline from "../playerItemComponents/PlayerTextInputMultiline";
import PlayerWeather from "../playerItemComponents/PlayerWeather";
import PlayerYesNo from "../playerItemComponents/PlayerYesNo";
import SyntheticVoiceApi from "../../speech/SyntheticVoiceApi";

//hardwire focus mode to false

// let ignoreMe = false;
//Placeholder
class PlayerItemWrapper extends React.PureComponent {

	constructor(props) {

		super(props);
		autoBind(this);
	}

	componentDidMount() {
	}

	componentWillUnmount() {
	}

	getItemKey(listIndex, sectionIndex, itemIndex) {
		let key = "player-list-" + listIndex + "-section-" + sectionIndex + "-item-" + itemIndex;
		return key;
	}

	createComments(comments) {
		return { __html: comments };
	}

	setSelectedItem(tree, i, j, k, id) {
		this.itemSelectedId = id;
		playerActions.setSelectedItem(tree, i, j, k);
	}


	handleShowItemModal() {
		playerActions.showItemModal();
	}

	handleShowCommentsModal(userNotesVisible, hasComments) {
		this.props.dispatch(
			playerActions.showComments,
			null,
			userNotesVisible,
			hasComments
		);
	}

	handleItemSubmit(submitInfo) {
		if (!submitInfo || !_.isPlainObject(submitInfo)) {
			return;
		}
		console.log("HANDLE SUBMIT Check Item", submitInfo);
		const { checked, listIndex, sectionIndex, itemIndex, identityId, linkOnCheck, linkId, linkActionType,disabled } = submitInfo;

		if (!disabled) {
			playerActions.setItemChecked(
				this.context.tree,
				listIndex, sectionIndex, itemIndex,
				checked,
				identityId,
				linkOnCheck,
				linkId,
				linkActionType
			);
		}
	}

	handleItemPickerSubmit(submitInfo) {
		if (!submitInfo || !_.isPlainObject(submitInfo)) {
			return;
		}
		console.log("HANDLE SUBMIT Picker", submitInfo);
		const { value, listIndex, sectionIndex, itemIndex, identityId, disabled, forceNav, speakValue } = submitInfo;

		if (!disabled) {
			const { tree } = this.context;
			if (value === null || value === "") {
				playerActions.handleChangeProperty(tree, listIndex, sectionIndex, itemIndex, "checked", false);
			}
			let li = Utils.getLinkInfo(this.props.item, value);
			//listIndex, sectionIndex, itemIndex, value, identityId, linkOnSelect, linkId = "", linkActionType, speak = false, forceNav = false, forceSpeak = false
			playerActions.setItemPickerChecked(
				tree,
				listIndex, sectionIndex, itemIndex,
				value,
				identityId,
				li.linkOnSelect,
				li.linkId,
				li.linkActionType,
				!forceNav,
				forceNav,
				speakValue
			);
		}
	}

	handleItemYesNoSubmit(submitInfo) {
		if (!submitInfo || !_.isPlainObject(submitInfo)) {
			return;
		}
		console.log("HANDLE SUBMIT Yes/No", submitInfo);
		const { value, listIndex, sectionIndex, itemIndex, identityId, disabled, forceNav,item } = submitInfo;

			if (!disabled) {
				const linkOnSelect = (item.hasOwnProperty("yesNoLinkOnSelect") ? item.yesNoLinkOnSelect : false);
				const linkInfo = Utils.getLinkInfo(item, value);

				playerActions.setItemYesNoChecked(
					this.context.tree,
					listIndex, sectionIndex, itemIndex,
					value,
					identityId,
					linkOnSelect,
					linkInfo.linkActionType,
					linkInfo.linkId,
					forceNav
				);
			}
		
	}

	handleChangeValue(changeValueInfo) {
		if (!changeValueInfo || !_.isPlainObject(changeValueInfo)) {
			return;
		}
		const { value, listIndex, sectionIndex, itemIndex, disabled, uncheckOnEmptyValue = false } = changeValueInfo;
		if (!disabled) {
			const { tree } = this.context;
			if (uncheckOnEmptyValue && (value === null || value === "")) {
				playerActions.handleChangeProperty(tree, listIndex, sectionIndex, itemIndex, "checked", false);
			}
			playerActions.handleChangeProperty(
				tree,
				listIndex, sectionIndex, itemIndex,
				"value",
				value
			);
		}
	}

	render() {
		const { ignoreVisibility } = this.props;
		let self = this;

		const webMode = getConfigParam("webMode", false);

		const focusedMode = this.props.focusedMode;

		let identityId = this.props.user.identityId;

		const theme = window.activityTheme && !_.isEmpty(window.activityTheme) ? window.activityTheme : this.props.activityTheme;
		//this is for the case where an admin might be editing an existing checklist
		let activityIdentityId = this.props.activityIdentityId;
		//let identityId = "test-identity-id";

		let item = this.props.item;
		let i = this.props.listIndex;
		let j = this.props.sectionIndex;
		let k = this.props.itemIndex;

		let listStyles = this.props.listStyles;
		let sectionStyles = this.props.sectionStyles;

		//let comments;
		//let notes;
		let mediaAttachmentsComponent;

		/*
		if (item.hasOwnProperty("comments") && item.comments !== "" && self.props.hasOwnProperty("preview") && self.props.preview) {
			comments =
				<div style={{ borderStyle: "solid", borderWidth: 1, borderColor: "gold", borderRadius: 5, backgroundColor: "lightyellow", padding: 10, margin: 10 }}>
					<b>Comments</b><br />
					<div dangerouslySetInnerHTML={self.createComments(item.comments)} />
				</div>;
		}


		if (item.hasOwnProperty("notes") && item.notes !== "") {
			notes =
				<div style={{ borderStyle: "solid", borderWidth: 1, borderColor: "blue", borderRadius: 5, backgroundColor: "lightblue", padding: 10, margin: 10 }}>
					<b>Notes</b><br />
					{item.notes}
				</div>;
		}
		*/

		let mediaAttachments;
		if (item.hasOwnProperty("mediaAttachmentsUrls") && item.mediaAttachmentsUrls.length > 0) {
			try {
				let imgUrls = "";
				for (let i = 0; i < item.mediaAttachmentsUrls.length; i++) {
					// Need to loop through all values
					let imgUrlParts = item.mediaAttachmentsUrls[i].split(".");
					let ext = imgUrlParts[imgUrlParts.length - 1];
					let imgUrl;
					if (ext === "mp4" || ext === "mov" || ext === "avi") {
						imgUrl = "<p><b>Video Thumbnail</b><br/><a href='" + item.mediaAttachmentsUrls[i].replace("." + ext, ".mp4") + "' target='blank'><img src='" + item.mediaAttachmentsUrls[i].replace("." + ext, "-00001.png") + "' /></a></p>";
					} else {
						imgUrl = "<p><b>Photo</b><br/><a href='" + item.mediaAttachmentsUrls[i] + "' target='blank'><img style='width: 50%' src='" + item.mediaAttachmentsUrls[i] + "' /></a></p>";
					}

					imgUrls = imgUrls + imgUrl;
				}

				mediaAttachments =
					<div style={{ display: "flex", alignItems: "center", width: "100%" }}>
						<div style={{ width: "100%", overflowX: "auto" }}>
							<div dangerouslySetInnerHTML={markdownToHtml(imgUrls)} />
						</div>
					</div>;

			} catch (e) {
				alert(e);
			}

			mediaAttachmentsComponent =
				<div style={{ borderStyle: "solid", borderWidth: 1, borderColor: "blue", borderRadius: 5, backgroundColor: "lightblue", padding: 10, margin: 10 }}>
					<b>Media Attachments</b><br />
					{mediaAttachments}
				</div>;
		}

		let component;
		let itemVisible = Utils.isVisible(item) || ignoreVisibility;
		let selected = (itemVisible) ? playerActions.itemSelected(self.context.tree, i, j, k) : false;
		const disabled = item.hasOwnProperty("enabled") && !item.enabled;

		if (item.type.toLowerCase() === "item") {
			component = <PlayerItem
				theme={_.get(this.props.activityTheme, "item.check")}
				listIndex={i}
				sectionIndex={j}
				itemIndex={k}
				item={item}
				identityId={identityId}
				onLabelClick={this._onClick}
				activityStyles={this.props.activity.styles}
				listStyles={listStyles}
				sectionStyles={sectionStyles}
				readOnly={self.props.readOnly}
				showMode={self.props.showMode}
				disabled={disabled}
				onSubmit={this.handleItemSubmit}
				selected={selected}
				isStartOfGroup={this.props.isStartOfGroup}
			/>;
		} else if (item.type.toLowerCase() === "itemtextinput") {
			try {
				component = <PlayerTextInput
					theme={_.get(this.props.activityTheme, "item.textInput")}
					listIndex={i}
					sectionIndex={j}
					itemIndex={k}
					item={item}
					identityId={identityId}
					onLabelClick={this._onClick}
					activityStyles={this.props.activity.styles}
					listStyles={listStyles}
					sectionStyles={sectionStyles}
					readOnly={self.props.readOnly}
					showMode={self.props.showMode}
					disabled={disabled}
					onChange={this.handleChangeValue}
					onSubmit={(value) => {
						if (!disabled) {
							playerActions.setItemTextInputChecked(
								self.context.tree,
								i, j, k,
								value,
								identityId,
								item.linkOnCheck,
								item.linkId,
								item.linkActionType
							);
						}
					}}
					selected={selected} />;
			} catch (e) {
				console.error(e);
			}
		} else if (item.type.toLowerCase() === "itemtextinputmultiline") {
			try {
				component = <PlayerTextInputMultiline
					theme={_.get(this.props.activityTheme, "item.textInputMultiline")}
					listIndex={i}
					sectionIndex={j}
					itemIndex={k}
					item={item}
					identityId={identityId}
					onLabelClick={this._onClick}
					activityStyles={this.props.activity.styles}
					listStyles={listStyles}
					sectionStyles={sectionStyles}
					readOnly={self.props.readOnly}
					showMode={self.props.showMode}
					disabled={disabled}
					onChange={this.handleChangeValue}
					onSubmit={(value) => {
						if (!disabled) {
							playerActions.setItemTextInputChecked(
								self.context.tree,
								i, j, k,
								value,
								identityId,
								item.linkOnCheck,
								item.linkId,
								item.linkActionType
							);
						}
					}} />;
			} catch (e) {
				console.error(e);
			}
		} else if (item.type.toLowerCase() === "itempicker") {
			try {
				component = <PlayerPicker
					theme={_.get(this.props.activityTheme, "item.picker")}
					listIndex={i}
					sectionIndex={j}
					itemIndex={k}
					item={item}
					identityId={identityId}
					onLabelClick={this._onClick}
					activityStyles={this.props.activity.styles}
					listStyles={listStyles}
					sectionStyles={sectionStyles}
					readOnly={self.props.readOnly}
					showMode={self.props.showMode}
					disabled={disabled}
					onChange={this.handleChangeValue}
					onSubmit={this.handleItemPickerSubmit}
					selected={selected} />;
			} catch (e) {
				console.error(e);
			}
		} else if (item.type.toLowerCase() === "itemranking") {
			try {
				component = <PlayerRanking
					theme={_.get(this.props.activityTheme, "item.picker")}
					listIndex={i}
					sectionIndex={j}
					itemIndex={k}
					item={item}
					identityId={identityId}
					onLabelClick={this._onClick}
					activityStyles={this.props.activity.styles}
					listStyles={listStyles}
					sectionStyles={sectionStyles}
					readOnly={self.props.readOnly}
					showMode={self.props.showMode}
					disabled={disabled}
					onChange={(value) => {
						if (!disabled) {
							playerActions.handleChangeProperty(
								self.context.tree,
								i, j, k,
								"value",
								value
							);
						}
					}}
					onSubmit={(value) => {
						if (!disabled) {
							playerActions.setItemRankingChecked(
								self.context.tree,
								i, j, k,
								value,
								identityId
							);
						}
					}}
					selected={selected} />;
			} catch (e) {
				console.error(e);
			}
		} else if (item.type.toLowerCase() === "itemyesno") {
			try {
				component = <PlayerYesNo
					theme={_.get(this.props.activityTheme, "item.yesNo")}
					listIndex={i}
					sectionIndex={j}
					itemIndex={k}
					item={item}
					identityId={identityId}
					onLabelClick={this._onClick}
					activityStyles={this.props.activity.styles}
					listStyles={listStyles}
					sectionStyles={sectionStyles}
					readOnly={self.props.readOnly}
					showMode={self.props.showMode}
					disabled={disabled}
					onChange={this.handleChangeValue}
					onSubmit={this.handleItemYesNoSubmit}
					selected={selected} />;
			} catch (e) {
				console.error(e);
			}
		} else if (item.type.toLowerCase() === "itembarcodescanner") {
			try {
				component = <PlayerBarcodeScanner
					theme={_.get(this.props.activityTheme, "item.barcodeScanner")}
					listIndex={i}
					sectionIndex={j}
					itemIndex={k}
					item={item}
					onLabelClick={this._onClick}
					activityStyles={this.props.activity.styles}
					listStyles={listStyles}
					sectionStyles={sectionStyles}
					readOnly={self.props.readOnly}
					showMode={self.props.showMode}
					disabled={disabled}
					onChange={(value) => {
						if (!disabled) {
							playerActions.handleChangeProperty(
								self.context.tree,
								i, j, k,
								"value",
								value
							);
						}
					}}
					onSubmit={(value) => {
						if (!disabled) {
							playerActions.setItemBarcodeChecked(
								self.context.tree,
								i, j, k,
								value,
								identityId
							);
						}
					}}
					selected={selected} />;
			} catch (e) {
				console.error(e);
			}
		} else if (item.type.toLowerCase() === "itemimagepicker") {
			try {
				component = <PlayerImagePicker
					theme={_.get(this.props.activityTheme, "item.mediaPicker")}
					listIndex={i}
					sectionIndex={j}
					itemIndex={k}
					item={item}
					onLabelClick={this._onClick}
					activityStyles={this.props.activity.styles}
					listStyles={listStyles}
					sectionStyles={sectionStyles}
					readOnly={self.props.readOnly}
					identityId={(activityIdentityId) ? activityIdentityId : identityId}
					showMode={self.props.showMode}
					disabled={disabled}
					onChange={(value, valueUrls) => {
						if (!disabled) {
							playerActions.handleChangeProperty(
								self.context.tree,
								i, j, k,
								"value",
								value
							);
							playerActions.handleChangeProperty(
								self.context.tree,
								i, j, k,
								"valueUrls",
								valueUrls
							);
							playerActions.addMediaAttachmentHistoryEntry(
								self.context.tree,
								i, j, k,
								value,
								valueUrls,
								true,
								identityId);
						}
					}}
					onSubmit={(value, valueUrls) => {
						if (!disabled) {
							playerActions.setItemImagePickerAddMedia(
								self.context.tree,
								i, j, k,
								value,
								valueUrls,
								true,
								identityId
							);
						}
					}}
					selected={selected} />;
			} catch (e) {
				console.error(e);
			}
		} else if (item.type.toLowerCase() === "itemsketchpad") {
			try {
				component = <PlayerSketchpad
					theme={_.get(this.props.activityTheme, "item.sketchPad")}
					listIndex={i}
					sectionIndex={j}
					itemIndex={k}
					item={item}
					onLabelClick={this._onClick}
					activityStyles={this.props.activity.styles}
					listStyles={listStyles}
					sectionStyles={sectionStyles}
					readOnly={self.props.readOnly}
					disabled={disabled}
					onSubmit={() => {
						if (!disabled) {
							playerActions.setItemSketchPadChecked(
								self.context.tree,
								i, j, k,
								identityId,
							);
						}
					}}
					showMode={self.props.showMode} />;
			} catch (e) {
				console.error(e);
			}
		} else if (item.type.toLowerCase() === "itemweather") {
			try {
				component = <PlayerWeather
					theme={_.get(this.props.activityTheme, "item.weather")}
					listIndex={i}
					sectionIndex={j}
					itemIndex={k}
					item={item}
					onLabelClick={this._onClick}
					activityStyles={this.props.activity.styles}
					listStyles={listStyles}
					sectionStyles={sectionStyles}
					readOnly={self.props.readOnly}
					disabled={disabled}
					onSubmit={(value) => {
						if (!disabled) {
							playerActions.setItemWeatherChecked(
								self.context.tree,
								i, j, k,
								value,
								identityId,
								item.linkOnCheck,
								item.linkId,
								item.linkActionType
							);
						}
					}}
					showMode={self.props.showMode} />;
			} catch (e) {
				console.error(e);
			}
		} else if (item.type.toLowerCase() === "itemdate" || item.type.toLowerCase() === "itemtime" || item.type.toLowerCase() === "itemdatetime") {
			try {
				component = <PlayerDatePicker
					theme={_.get(this.props.activityTheme, "item.datePicker")}
					listIndex={i}
					sectionIndex={j}
					itemIndex={k}
					item={item}
					onLabelClick={this._onClick}
					activityStyles={this.props.activity.styles}
					listStyles={listStyles}
					sectionStyles={sectionStyles}
					readOnly={self.props.readOnly}
					showMode={self.props.showMode}
					disabled={disabled}
					onChange={(value) => {
						if (!disabled) {
							playerActions.handleChangeProperty(
								self.context.tree,
								i, j, k,
								"value",
								value
							);
						}
					}}
					onSubmit={(value, omitReadValue=false) => {
						if (!disabled) {
							const mode = Utils.getDateMode(item.type);
							playerActions.setItemDateChecked(
								self.context.tree,
								i, j, k,
								value,
								mode,
								identityId,
								item.linkOnCheck,
								item.linkId,
								item.linkActionType,
								omitReadValue
							);
						}
					}}
					selected={selected} />;
			} catch (e) {
				console.error(e);
			}
		} else if (item.type.toLowerCase() === "itemaddress") {
			try {
				component = <PlayerAddress
					theme={_.get(this.props.activityTheme, "item.addressSearch")}
					listIndex={i}
					sectionIndex={j}
					itemIndex={k}
					item={item}
					onLabelClick={this._onClick}
					activityStyles={this.props.activity.styles}
					listStyles={listStyles}
					sectionStyles={sectionStyles}
					readOnly={self.props.readOnly}
					showMode={self.props.showMode}
					disabled={disabled}
					onChange={(value) => {
						if (!disabled) {
							playerActions.handleChangeProperty(
								self.context.tree,
								i, j, k,
								"value",
								value
							);
						}
					}}
					onSubmit={(value) => {
						if (!disabled) {
							playerActions.setItemLocationChecked(
								self.context.tree,
								i, j, k,
								value,
								identityId,
								item.linkOnCheck,
								item.linkId,
								item.linkActionType
							);
						}
					}}
					selected={selected} />;
			} catch (e) {
				console.error(e);
			}
		} else if (item.type.toLowerCase() === "itemlocation") {
			try {
				component = <PlayerLocation
					theme={_.get(this.props.activityTheme, "item.addressSearch")}
					listIndex={i}
					sectionIndex={j}
					itemIndex={k}
					item={item}
					onLabelClick={this._onClick}
					activityStyles={this.props.activity.styles}
					listStyles={listStyles}
					sectionStyles={sectionStyles}
					readOnly={self.props.readOnly}
					showMode={self.props.showMode}
					disabled={disabled}
					onChange={(value) => {
						if (!disabled) {
							playerActions.handleChangeProperty(
								self.context.tree,
								i, j, k,
								"value",
								value
							);
						}
					}}
					onSubmit={(value) => {
						if (!disabled) {
							playerActions.setItemLocationChecked(
								self.context.tree,
								i, j, k,
								value,
								identityId,
								item.linkOnCheck,
								item.linkId,
								item.linkActionType
							);
						}
					}}
					selected={selected} />;
			} catch (e) {
				console.error(e);
			}
		} else if (item.type.toLowerCase() === "itemchoicemulti") {
			try {
				component = <PlayerMultiChoice
					theme={_.get(this.props.activityTheme, "item.choice")}
					listIndex={i}
					sectionIndex={j}
					itemIndex={k}
					item={item}
					onLabelClick={this._onClick}
					activityStyles={this.props.activity.styles}
					listStyles={listStyles}
					sectionStyles={sectionStyles}
					readOnly={self.props.readOnly}
					disabled={disabled}
					onChange={(value) => {
						if (!disabled) {
							playerActions.handleChangeProperty(
								self.context.tree,
								i, j, k,
								"value",
								value
							);
						}
					}}
					onSubmit={(value) => {
						if (!disabled) {
							playerActions.setItemChoiceMultiChecked(
								self.context.tree,
								i, j, k,
								value,
								identityId,
								item.linkOnCheck,
								item.linkId,
								item.linkActionType
							);
						}
					}} />;
			} catch (e) {
				console.error(e);
			}
		} else if (item.type.toLowerCase() === "itemchoicesingle") {
			try {
				component = <PlayerSingleChoice
					theme={_.get(this.props.activityTheme, "item.choice")}
					listIndex={i}
					sectionIndex={j}
					itemIndex={k}
					item={item}
					onLabelClick={this._onClick}
					activityStyles={this.props.activity.styles}
					listStyles={listStyles}
					sectionStyles={sectionStyles}
					readOnly={self.props.readOnly}
					showMode={self.props.showMode}
					disabled={disabled}
					onChange={(value) => {
						if (!disabled) {
							playerActions.handleChangeProperty(
								self.context.tree,
								i, j, k,
								"value",
								value
							);
						}
					}}
					onSubmit={(value, choiceItem) => {
						if (!disabled) {
							playerActions.setItemChoiceSingleChecked(
								self.context.tree,
								i, j, k,
								value,
								choiceItem,
								identityId,
								item.linkOnCheck,
								item.linkId,
								item.linkActionType
							);
						}
					}}
					selected={selected} />;
			} catch (e) {
				console.error(e);
			}
		}

		//TODO: Does visible logic belong outside component?

		let itemComponent = null;
		let key = self.getItemKey(i, j, k);
		if (itemVisible) {


			const borderColorBase = this.props.isInGroup ? theme.itemGroup.itemBorder : theme.item;


			let additionalStyles = {};
			if (item.resolvedStyles && item.resolvedStyles.item) {
				additionalStyles = item.resolvedStyles.item;
			}

			//let borderColor = Utils.getThemeValue("item.selectedDisabledColor", "lightgray");		

			let borderColor = borderColorBase.selectedDisabledColor;

			if (item.selected) {
				//borderColor = Utils.getThemeValue("item.selectedColor", "green");
				borderColor = borderColorBase.selectedColor;
			}

			let notSelectedDiv;

			if (selected) {
				borderColor = borderColorBase.selectedColor;
			} else if (focusedMode) {
				//overlay transparent div if focusMode is on and item not selected
				notSelectedDiv = <div style={{ width: "100%", height: "100%", position: "absolute", left: "0px", top: "0px", zIndex: 2 }}></div>;
			}

			let type = item.type.toLowerCase();

			// let showItemModalButtonComponent;
			// let fullscreenIcon;
			// const hasFullscreen = self.props.showItemModalButton;
			// const fullscreenIconColor = selected ? theme.attachments.selectedIcon.color : theme.attachments.icon.color;
			// if (hasFullscreen) {
			// 	fullscreenIcon =
			// 		<div key="fullscreen-icon" style={{ width: 20, height: 20, fontSize: 16, display: "flex", alignItems: "center", justifyContent: "center" }}>
			// 			<FontAwesomeIcon icon='expand' color={fullscreenIconColor} style={{ color: fullscreenIconColor }} />
			// 		</div>;
			// 	showItemModalButtonComponent = fullscreenIcon;
			// }

			const dialComponents = [];

			let commentsIcon;
			const hasComments = !Utils.isBlank(item.comments);
			const commentsNotesIconColor = selected ? theme.attachments.selectedIcon.color : theme.attachments.icon.color;
			if (hasComments) {
				commentsIcon =
					<div key="comments-icon" style={{ width: 20, height: 20, fontSize: 16, display: "flex", alignItems: "center", justifyContent: "center" }}>
						<FontAwesomeIcon icon='file-alt' color={commentsNotesIconColor} style={{ color: commentsNotesIconColor }} />
					</div>;
				dialComponents.push(commentsIcon);
			}

			let notesIcon;
			if (!Utils.isBlank(item.notes)) {
				notesIcon =
					<div key="notes-icon" style={{ width: 20, height: 20, fontSize: 16, display: "flex", alignItems: "center", justifyContent: "center" }}>
						<FontAwesomeIcon icon='sticky-note' color={commentsNotesIconColor} style={{ color: commentsNotesIconColor }} />
					</div>;
				dialComponents.push(notesIcon);
			}

			let sketchPadImageIcon;
			if (!_.isEmpty(item.sketchPadImage)) {
				sketchPadImageIcon =
					<div key="sketchPad-icon" style={{ width: 20, height: 20, fontSize: 16, display: "flex", alignItems: "center", justifyContent: "center" }}>
					<FontAwesomeIcon icon='pencil-paintbrush' color={commentsNotesIconColor} style={{ color: commentsNotesIconColor }} />
					</div>;
				dialComponents.push(sketchPadImageIcon);
			}

			let mediaIcon;
			if (!Utils.isBlank(item.mediaAttachments) && item.mediaAttachments.length > 0) {
				mediaIcon =
					<div key="media-icon" style={{ width: 20, height: 20, fontSize: 16, display: "flex", alignItems: "center", justifyContent: "center" }}>
						<FontAwesomeIcon icon='image' color={commentsNotesIconColor} style={{ color: commentsNotesIconColor }} />
					</div>;
				dialComponents.push(mediaIcon);
			}

			// let showItemModalButtonIcon;
			let commentsNotesIcon;
			let itemContainerPadding = 10;

			/*
			Adding + icon causes content to shift left
			*/

			let focusedModeSelection = "";
			if (focusedMode) {
				if (!selected) {
					//borderColor = Utils.getThemeValue("item.selectedDisabledColorFocusedMode", "lightgray");
					borderColor = borderColorBase.selectedDisabledColorFocusedMode;
				}
				focusedModeSelection = " not-selected";
			}
			const userNotesVisible = (this.props.commentsVisibility === "visible");

			if (selected && dialComponents.length === 0 && userNotesVisible) {
				let plusIcon = <div key="plus-icon" style={{ width: 20, fontSize: 16, height: 20, display: "flex", alignItems: "center", justifyContent: "center", paddingTop: "1px" }}>
					<FontAwesomeIcon icon='plus' color={commentsNotesIconColor} style={{ color: commentsNotesIconColor }} />
				</div>;
				dialComponents.push(plusIcon);
			}
			
			let _style = _.assign({}, { display: "flex", flexDirection: "column", borderStyle: "solid", borderColor: borderColor, borderRadius: 5, backgroundColor: item.labelOnly ? !_.isEmpty(item.labelOnlyBackgroundColor) ? item.labelOnlyBackgroundColor : "" : item.backgroundColor ? item.backgroundColor : "", padding: itemContainerPadding, margin: 5, position: "relative", "pointerEvents": type === "item" ? "none" : null }, additionalStyles);

			if (this.props.isInGroup) {
				console.debug("Group item", _style, borderColor, borderColorBase);
			}

			// if (showItemModalButtonComponent) {
			// 	itemContainerPadding = "10px 18px 10px 10px";
			// 	let showItemModalFunc = (selected) ? () => this.handleShowItemModal() : null;

			// 	let borderTopLeftRadius = 15;
			// 	let paddingRight = 10;
			// 	let paddingTop = 10;

			// 	if (_style.hasOwnProperty("borderRadius") && _.isNumber(_style.borderRadius)) {
			// 		borderTopLeftRadius = _style.borderRadius;
			// 	}
			// 	if (_style.hasOwnProperty("borderTopRightRadius") && _.isNumber(_style.borderTopRightRadius)) {
			// 		borderTopLeftRadius = _style.borderTopLeftRadius;
			// 		if (borderTopLeftRadius > 15) {
			// 			paddingRight += borderTopLeftRadius - 15;
			// 			paddingTop += borderTopLeftRadius - 15;
			// 		}
			// 	}

			// 	showItemModalButtonIcon =
			// 		<div onClick={showItemModalFunc} style={{ padding: 10, paddingRight, paddingTop, position: "absolute", width: 30, minHeight: 30, left: -2, top: -2, borderBottomLeftRadius: 15, borderTopLeftRadius, backgroundColor: borderColor, display: "flex", flexDirection: "row", flexWrap: "wrap", justifyContent: "center", alignItems: "center", zIndex: 10, cursor: (selected) ? "pointer" : "", pointerEvents: disabled ? "none" : "all" }}>
			// 			{showItemModalButtonComponent}
			// 		</div>;
			// }

			if (dialComponents.length > 0) {
				itemContainerPadding = "10px 18px 10px 10px";
				let showCommentsModalFunc = (selected) ? () => this.handleShowCommentsModal(userNotesVisible, hasComments) : null;

				let borderTopRightRadius = 15;
				let paddingLeft = 10;
				let paddingTop = 10;

				if (_style.hasOwnProperty("borderRadius") && _.isNumber(_style.borderRadius)) {
					borderTopRightRadius = _style.borderRadius;
				}
				if (_style.hasOwnProperty("borderTopRightRadius") && _.isNumber(_style.borderTopRightRadius)) {
					borderTopRightRadius = _style.borderTopRightRadius;
					if (borderTopRightRadius > 15) {
						paddingLeft += borderTopRightRadius - 15;
						paddingTop += borderTopRightRadius - 15;
					}
				}

				commentsNotesIcon =
					<div onClick={showCommentsModalFunc} style={{ padding: 10, paddingLeft, paddingTop, position: "absolute", width: 30, minHeight: 30, right: -2, top: -2, borderBottomLeftRadius: 15, borderTopRightRadius, backgroundColor: borderColor, display: "flex", flexDirection: "row", flexWrap: "wrap", justifyContent: "center", alignItems: "center", zIndex: 10, cursor: (selected) ? "pointer" : "", pointerEvents: disabled ? "none" : "all" }}>
						{dialComponents}
					</div>;
			}

			let opacity = 1;
			const { fullScreen } = this.props;
			if (!fullScreen) {
				if ((this.props.focusedMode && !selected) || !item.enabled) {
					opacity = 0.8;
				}
			}

			let innerItemComponent = <div className="disable-select" style={{ padding: itemContainerPadding, pointerEvents: disabled ? "none" : "all" }}>
				<div style={{ display: "flex", alignItems: "center", width: "100%", pointerEvents: disabled ? "none" : "all", wordBreak: "break-word" }}>
					{component}
				</div>
				{/* {!webMode && showItemModalButtonIcon} */}
				{!webMode && commentsNotesIcon}
				{!webMode && mediaAttachmentsComponent}
				{!fullScreen && notSelectedDiv}
				{disabled && <div style={{ position: "absolute", zIndex: 2, top: 0, right: 0, bottom: 0, left: 0, width: "100%", height: "100%", pointerEvents: "none" }} onClick={(e) => { e.stopPropagation(); }}></div>}
			</div>;


			// if (selected) {
			// 	innerItemComponent = <ClickNHold time={1} onClickNHold={this.handleShowCommentsModalLongPress}>
			// 		{innerItemComponent}
			// 	</ClickNHold>;
			// }

			if (fullScreen) {
				_style = _.assign({}, _style, { width: "100%", height: "100%", borderWidth: 0, padding: 15, justifyContent: "center", alignItems: "center", margin: 0 });
			}

			if (self.props.showMode !== true) {
				// // console.debug(item);


				itemComponent = <div key={key} id={key} className={`player-item${selected || fullScreen ? " selected" : focusedModeSelection}${disabled ? " disabled" : ""}`} style={_style}
					onClick={(webMode || disabled) ? () => { return; } : () => this._onClick}>
					{innerItemComponent}
					{!webMode && !selected && !fullScreen &&
						<div style={{ position: "absolute", pointerEvents: "auto", top: 0, left: 0, bottom: 0, right: 0, opacity: opacity, zIndex: 2 }}
							onClick={(e) => {
								e.stopPropagation();
								// self.setSelectedItem(self.context.tree, i, j, k, key);
								this._onClick();
							}}
						>
						</div>
					}
				</div>;
			} else {

				// if (selected) {
				// 	additionalStyles = _.assign(additionalStyles, Utils.getSelectedStyles(item.resolvedStyles.item));
				// }

				const _style = _.assign({}, { display: "flex", flexDirection: "column" }, additionalStyles);
				itemComponent = <div onClick={this._onClick} key={key} className={`showMode player-item${selected ? " selected" : ""}`} id={key} style={_style}>
					<div style={{ display: "flex", alignItems: "center", width: "100%" }}>
						{component}
					</div>
					{mediaAttachmentsComponent}
					{commentsNotesIcon}
				</div>;
			}
		}

		return <OkButtonContext.Provider key={`ok-button-${item.guid}`} value={{
			styles: item.resolvedStyles && item.resolvedStyles.itemOkButton ? item.resolvedStyles.itemOkButton : {},
			label: item.itemButtonOkLabel,
			visibility: item.itemButtonOkVisibility
		}}>{itemComponent}</OkButtonContext.Provider>;
	}

	_onClick() {
		// console.debug("In Item _onPressButton");
		if (this.props.fullScreen && this.props.suppressNav) {
			// Ignore button presses when in full screen mode
			return;
		}
		let item = this.props.overrides ? _.assign({}, this.props.item, this.props.overrides) : this.props.item;
		if (this.props.overrides2) {
			item = _.assign({}, item, this.props.overrides2);
		}
		// let voices = this.context.tree.get(["appPreferences", "voice", "voices"]);
		let audio = this.context.tree.get(["appPreferences", "voice", "audio"]);

		// this.state.labelPressed = true;

		if (SyntheticVoiceApi.isSpeaking() && item.selected) {
			// console.debug("Just stop it...");
			SyntheticVoiceApi.stop();
		} else {
			SyntheticVoiceApi.stop();
			// Move to Actions
			// if (!item.selected) {
			// 	// const prevItem = playerActions.getPreviousItem(this.context.tree, this.props.listIndex, this.props.sectionIndex, this.props.itemIndex);
			// 	// console.debug("PREV ITEM", prevItem);
			// 	// if (prevItem && prevItem.selected) {
			// 		SyntheticVoiceApi.setDefaultVoice(voices.secondary);
			// 		SyntheticVoiceApi.speak(this.props.content.mira.responses.skip);
			// 		SyntheticVoiceApi.setDefaultVoice(voices.primary);
			// 	// }
			// }

			// const suppressAudio = !!item.suppressAudio;

			// const suppressAudioLabel1 = !!item.suppressAudioLabel1;
			// const suppressAudioLabel2 = !!item.suppressAudioLabel2;
		
			// if (!suppressAudio && this.context.tree.get("appPreferences", "voice", "audio")) {
			// 	const prop = [];
			// 	if (!suppressAudioLabel1) {
			// 		prop.push("label1");
			// 	}
			// 	if (this.props.checkLabel || item.label2 !== this.props.content.mira.responses.check) {
			// 		if (!suppressAudioLabel2) {
			// 			prop.push("label2");
			// 		}
			// 	}

			// 	SyntheticVoiceApi.speakItem(item, { prop });
			// }

			if (/*item.labelOnly || */!audio) {
				if (item.selected) {
					// let linkOnCheck = (item.hasOwnProperty("linkOnCheck") && item.linkOnCheck);
					// let linkId = (item.hasOwnProperty("linkId") && item.linkId);
					// let linkActionType = (item.hasOwnProperty("linkActionType") && item.linkActionType);
					playerActions.setNextItemChecked(this.context.tree);
					// playerActions.setItemChecked(this.context.tree, this.props.listIndex, this.props.sectionIndex, this.props.itemIndex, true, linkOnCheck, linkId, linkActionType);
				} else {
					this.props.dispatch(
						playerActions.setSelectedItem,
						this.props.listIndex,
						this.props.sectionIndex,
						this.props.itemIndex,
						true
					);
				}
			} else {
				this.props.dispatch(
					playerActions.setSelectedItemAndSpeak,
					this.props.listIndex,
					this.props.sectionIndex,
					this.props.itemIndex,
					false,false,0,false
				);
			}
		}
	}
}

PlayerItemWrapper.contextTypes = {
	tree: PropTypes.baobab
};

export default branch((props, context) => {

	return {
		checkLabel: ["appPreferences", "voice", "checkLabel"],
		content: ["content"],
		associatedContent: ["associatedContentCard"],
		activityTheme: ["activity", "theme"],
		appCapabilitiesPlayer: ["appCapabilities", "views", "player"],
		showComments: ["player", "showComments"],
		user: ["user"],
		focusedMode: Utils.getFocusedModeBranchPath(context.tree),
		commentsVisibility: Utils.getCommentsVisibilityBranchPath(context.tree, props.listIndex, props.sectionIndex, props.itemIndex),
		itemModalVisible: ["appState", "itemModal", "visible"],
		// showItemModalButton: ["appState", "showItemModalButton"]
	};

}, PlayerItemWrapper);